import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiResponse } from '@core/interface/api-response.interface';
import { RefId } from '@core/interface/ref-id.interface';
import { UrlBuilder } from '@core/model/url-builder';
import { CreateManagementReportAccountingExecutionRequestDto } from '@domain/management-report-accounting-execution/dtos/create-management-report-accounting-execution.request.dto';
import { DispatchErpManagementReportAccountingExecutionRequestDto } from '@domain/management-report-accounting-execution/dtos/dispatch-erp-management-report-accounting-execution.request.dto';
import { DispatchErpManagementReportAccountingExecutionResponseDto } from '@domain/management-report-accounting-execution/dtos/dispatch-erp-management-report-accounting-execution.response.dto';
import { ManagementReportAccountingExecutionResponseDto } from '@domain/management-report-accounting-execution/dtos/management-report-accounting-execution.response.dto';
import { PreviewManagementReportAccountingExecutionResponseDto } from '@domain/management-report-accounting-execution/dtos/preview-management-report-accounting-execution.response.dto';

@Injectable({
  providedIn: 'root',
})
export class ManagementReportAccountingExecutionService extends UrlBuilder {
  constructor(private http: HttpClient) {
    super('management/report-accounting');
  }

  create(request: CreateManagementReportAccountingExecutionRequestDto) {
    const { managementReportAccounting, ...body } = request;
    const queryUrl = `${this.getApiUrl()}/execution/${managementReportAccounting}/create`;
    return this.http.post<
      ApiResponse<ManagementReportAccountingExecutionResponseDto>
    >(queryUrl, body);
  }

  show(request: RefId) {
    const { refId } = request;
    const queryUrl = `${this.getApiUrl()}/execution/show/${refId}`;
    return this.http.get<
      ApiResponse<ManagementReportAccountingExecutionResponseDto>
    >(queryUrl);
  }

  download(request: RefId) {
    const { refId } = request;
    const queryUrl = `${this.getApiUrl()}/execution/download/${refId}`;
    return this.http.get<ApiResponse<{ viewUrl: string }>>(queryUrl);
  }

  preview(request: RefId) {
    const { refId } = request;
    const queryUrl = `${this.getApiUrl()}/execution/preview/${refId}`;
    return this.http.get<
      ApiResponse<PreviewManagementReportAccountingExecutionResponseDto>
    >(queryUrl);
  }

  delete(request: RefId) {
    const { refId } = request;
    const queryUrl = `${this.getApiUrl()}/execution/${refId}`;
    return this.http.delete<ApiResponse<void>>(queryUrl);
  }

  dispatchErp(request: DispatchErpManagementReportAccountingExecutionRequestDto) {
    const { refId, ...body } = request;
    const queryUrl = `${this.getApiUrl()}/execution/${refId}/dispatch-erp`;
    return this.http.post<
      ApiResponse<DispatchErpManagementReportAccountingExecutionResponseDto>
    >(queryUrl, body);
  }
}
